import { render, staticRenderFns } from "./registerPay.vue?vue&type=template&id=6f90aeae&scoped=true&"
import script from "./registerPay.vue?vue&type=script&lang=js&"
export * from "./registerPay.vue?vue&type=script&lang=js&"
import style0 from "./registerPay.vue?vue&type=style&index=0&id=6f90aeae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90aeae",
  null
  
)

export default component.exports